export function findYDomain(data, options) {
  if (!data) return null

  const { minLimit, maxLimit } = options
    ? {
        minLimit: options.minLimit || -1,
        maxLimit: options.maxLimit || -1,
      }
    : {
        minLimit: -1,
        maxLimit: -1,
      }

  const _res = getMinMaxFromArray(data)

  let [resultMin, resultMax] = [_res.min, _res.max]

  // if override value, should be use override min,max
  if (minLimit !== -1) {
    resultMin = resultMin < minLimit ? minLimit : resultMin
  }
  if (maxLimit !== -1) {
    resultMax = resultMax > maxLimit ? maxLimit : resultMax
  }

  return [resultMin, resultMax]
}

export function getMinMaxFromArray(data) {
  let maxValue = Number.MIN_SAFE_INTEGER
  let minValue = Number.MAX_SAFE_INTEGER

  data.forEach((o) => {
    const { timestamp, ...newObj } = o

    const arr = Object.values(newObj)
    const min = Math.min(...arr)
    const max = Math.max(...arr)

    if (max > maxValue) maxValue = max
    if (min < minValue) minValue = min
  })

  return {
    max: maxValue,
    min: minValue,
  }
}

export function convertDayToTimestamp(day) {
  return day * (24 * 60 * 60)
}

export function convertWeekToTimestamp(week) {
  return week * (24 * 60 * 60 * 7)
}
